import Box from '@mui/material/Box';
import { IRecentSearchTile } from '../../utilities/types';
import Carousel from '../../../../components/carousels/mobile-recent-searches/Carousel';
import MobileRecentSearchTile from './MobileRecentSearchTile';

interface IMobileRecentSearchesCarouselProps {
    ariaLabel: string;
    carouselName: string;
    leftAligned: boolean;
    recentSearchTileList: IRecentSearchTile[];
}

const MobileRecentSearchesCarousel = ({
    ariaLabel,
    carouselName,
    leftAligned,
    recentSearchTileList,
}: IMobileRecentSearchesCarouselProps) => {
    if (recentSearchTileList.length === 0) {
        return <></>;
    }

    return (
        <Box>
            <Carousel
                name={`${carouselName}-return-visitor`}
                nextFocus="#you-might-like"
                ariaLabel={ariaLabel}
                leftAligned={leftAligned}
            >
                {recentSearchTileList.map((item, index) => (
                    <div className="carousel__slide" key={`recent-search-slide-${index}`}>
                        <div className="carousel-slide-item">
                            <MobileRecentSearchTile recentSearchTile={item} />
                        </div>
                    </div>
                ))}
            </Carousel>
        </Box>
    );
};

export default MobileRecentSearchesCarousel;
